/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

export enum AlarmSeverity {
  Notification = 1,
  Warning = 100,
  Error = 254
}

export interface AlarmModel {
  MachineId: string;
  MachineName: string;
  UserName: string;
  Package: string;
  NodeName: string;
  AlarmId: number;
  Severity: AlarmSeverity;
  Active: boolean;
  Acknowledged: boolean;
  Overridden: boolean;
  AlarmTime: Date;
  Description: string;
  Action: string;
  Parameters: string;
  AllowTransportation: boolean;
  Frequency: number;
  identifier?: string;
  CompositeKey: string;
  AlarmReference: string;
}

export interface FlightPathAlarmModel {
  MachineId: string;
  UserName: string;
  package: string;
  node_name: string;
  alarm_id: number;
  severity: AlarmSeverity;
  active: boolean;
  acknowledged: boolean;
  overridden: boolean;
  alarm_time: number;
  description: string;
  action: string;
  parameters: string;
  allow_transportation: boolean;
  frequency: number;
  alarm_reference: string;
}

// Converts JSON strings to/from your types
export class Convert {
  public static stringToAlarmModelList(json: string): AlarmModel[] {
    const flightPathModel = JSON.parse(json) as FlightPathAlarmModel[];
    const result: AlarmModel[] = [];

    flightPathModel.forEach((alarm) => {
      result.push({
        Active: alarm.active,
        AlarmTime: new Date(alarm.alarm_time * 1000),
        UserName: alarm.UserName,
        Package: alarm.package,
        NodeName: alarm.node_name,
        AlarmReference: alarm.alarm_reference,
        AlarmId: alarm.alarm_id,
        CompositeKey: `${alarm.alarm_reference}+${alarm.alarm_id}`,
        Severity: alarm.severity,
        Description: alarm.description,
        Overridden: alarm.overridden,
        Action: alarm.action,
        Parameters: alarm.parameters,
        AllowTransportation: alarm.allow_transportation,
        Frequency: alarm.frequency,
        MachineId: alarm.MachineId,
        Acknowledged: alarm.acknowledged,
        identifier: `${alarm.MachineId}-${alarm.node_name}-${alarm.alarm_id}`,
        MachineName: ''
      });
    });

    return result;
  }

  public static toFlightPathAlarmModelList(model: AlarmModel[]): FlightPathAlarmModel[] {
    const result: FlightPathAlarmModel[] = [];

    model.forEach((alarm) => {
      result.push({
        active: alarm.Active,
        alarm_time: alarm.AlarmTime.getTime() / 1000,
        UserName: alarm.UserName,
        package: alarm.Package,
        node_name: alarm.NodeName,
        alarm_id: alarm.AlarmId,
        severity: alarm.Severity,
        description: alarm.Description,
        overridden: alarm.Overridden,
        action: alarm.Action,
        parameters: alarm.Parameters,
        allow_transportation: alarm.AllowTransportation,
        frequency: alarm.Frequency,
        MachineId: alarm.MachineId,
        acknowledged: alarm.Acknowledged,
        alarm_reference: alarm.AlarmReference
      });
    });

    return result;
  }
}
